import { Injectable } from "@angular/core";
import { CarouselStore } from "../carousel/carousel.store";
import { CategoriesStore } from "../state/categories/categories.store";
import { CompanyStore } from "../state/companies/company.store";
import { Order } from "../state/orders/order.model";
import { ProductStore } from "../state/products/product.store";
import { extractCompanyId, Role } from "../state/roles/role.model";
import { RoleStore } from "../state/roles/role.store";
import { e2eCarousels, e2eCategories, e2eCompany, e2eOrders, e2eProducts, e2eRole } from "./e2e-fixtures";

interface ReportDateRange {
  fromDatetime: string;
  toDatetime: string;
  includeVoided: boolean;
}

@Injectable({ providedIn: "root" })
export class E2eFixtureService {
  constructor(
    private carouselStore: CarouselStore,
    private categoriesStore: CategoriesStore,
    private productStore: ProductStore,
    private roleStore: RoleStore,
    private companyStore: CompanyStore
  ) {}

  seed(): void {
    this.categoriesStore.set(e2eCategories);
    this.categoriesStore.setLoading(false);

    this.productStore.set(e2eProducts);
    this.productStore.setLoading(false);

    this.carouselStore.set(e2eCarousels);
    this.carouselStore.setLoading(false);

    this.roleStore.set([e2eRole]);
    this.roleStore.setLoading(false);

    this.companyStore.set([e2eCompany]);
    this.companyStore.setLoading(false);
  }

  getRoleOrdersReport(roleId: string, range: ReportDateRange): { roleName?: string; orders: Order[] } {
    const role = this.getRole(roleId);
    const company = role ? this.companyStore.getValue().entities[extractCompanyId(role)] : null;
    const from = new Date(range.fromDatetime).getTime();
    const to = new Date(range.toDatetime).getTime();

    return {
      roleName: role?.name,
      orders: e2eOrders.filter(order =>
        order.role === role?.name &&
        order.company === company?.name &&
        order.test === false &&
        orderDateMillis(order) >= from &&
        orderDateMillis(order) <= to &&
        (range.includeVoided || order.status !== "Voided")
      )
    };
  }

  private getRole(roleId: string): Role | undefined {
    return this.roleStore.getValue().entities[roleId];
  }
}

function orderDateMillis(order: Order): number {
  const orderDate: any = order.orderDate;
  if (orderDate?.toDate) {
    return orderDate.toDate().getTime();
  }
  if (typeof orderDate?.seconds === "number") {
    return orderDate.seconds * 1000;
  }
  return new Date(orderDate).getTime();
}
